import React, { useMemo, memo } from 'react';

interface EmailPreviewProps {
    html: string;
}

const EmailPreview: React.FC<EmailPreviewProps> = memo(({ html }) => {
    // Simple variable replacement for preview
    const renderedHtml = useMemo(() => {
        if (!html) return '';

        const variables: Record<string, string> = {
            user_name: 'John',
            dashboard_url: '#',
            rules_url: '#',
            unsubscribe_url: '#',
            support_email: 'ankitdaf@gmail.com',
            account_count: '2',
            unique_symbols: '5',
            holdings_count: '5',
            portfolio_count: '5',
            rules_count: '1',
            symbols_held: 'RELIANCE, TCS, INFY',
        };

        let result = html;
        Object.entries(variables).forEach(([key, value]) => {
            const placeholder = `{{${key}}}`;
            result = result.split(placeholder).join(value);
        });

        return result;
    }, [html]);

    if (!html) {
        return (
            <div className="h-full flex items-center justify-center text-slate-500 bg-slate-100">
                <p>Select a template to see preview</p>
            </div>
        );
    }

    return (
        <div className="h-full w-full bg-white">
            <iframe
                title="Email Preview"
                className="w-full h-full border-none"
                srcDoc={renderedHtml}
            />
        </div>
    );
});

EmailPreview.displayName = 'EmailPreview';

export default EmailPreview;
